(() => {
  const STYLE_ID = "rcf-forms-wide-style";

  function inject(embed) {
    const root = embed?.shadowRoot;
    if (!root) return;
    if (root.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      /* Shadow DOM safety: prevents width+padding from overflowing and getting clipped */
      :host, *, *::before, *::after {
        box-sizing: border-box !important;
      }

      @media (min-width: 990px) {
        [data-sizing="form-wrapper"],
        .form-container-ref,
        section[role="dialog"] {
          width: 100% !important;
          max-width: 100% !important;
          overflow: visible !important;
        }

        form {
          width: 100% !important;
          max-width: 100% !important;
        }

        input, select, textarea, button {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    `;

    root.appendChild(style);
  }

  function run() {
    document.querySelectorAll("shopify-forms-embed").forEach(inject);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  const mo = new MutationObserver(run);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
